<template>
  <div class="flex space-x-2 sm:space-x-8 overflow-hidden group">
    <div 
      class="animate-loop-scroll flex space-x-2 sm:space-x-8 group-hover:paused">
      <div v-for="brand in brands" :key="brand.website"
          class="cursor-pointer flex">
          <img width="64" height="64"
            loading="lazy"
            class="object-contain rounded-2xl shadow-md hover:opacity-75 hover:scale-125 m-10" style="color:transparent"
            :src="brand.logo">
      </div>
    </div>
    <div 
      class="animate-loop-scroll flex space-x-2 sm:space-x-8 group-hover:paused">
      <div v-for="brand in brands" :key="brand.website"
          class="cursor-pointer flex">
          <img loading="lazy" width="64" height="64"
            decoding="async" data-nimg="1"
            class="object-contain rounded-2xl shadow-md hover:opacity-75 hover:scale-125 m-10" style="color:transparent"
            :src="brand.logo">
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { getBrands } from '@/services/contentful/client'
import type { ContentfulBrand } from '@/services/contentful/types'

const brands = ref<ContentfulBrand[]>([])

onMounted(async () => {
  brands.value = (await getBrands()).reverse()
})
</script>